function defineGradients(svg, datasets, gradientIds) {
    // Append under line gradient
    const defs = svg.append("defs");
    datasets.forEach((dataset, i)=>{
        const grad = defs.append("linearGradient").attr("id", gradientIds[i]).attr("x1", "0%").attr("y1", "0%").attr("x2", "0%").attr("y2", "100%");
        grad.selectAll("stop").data([
            {
                offset: "0%",
                color: dataset.color || "blue",
                opacity: 0.1
            },
            {
                offset: "100%",
                color: dataset.color || "blue",
                opacity: 0
            }
        ]).enter().append("stop").attr("offset", (d)=>d.offset).attr("stop-color", (d)=>d.color).attr("stop-opacity", (d)=>d.opacity);
    });
}
export { defineGradients };
